(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cogi-impact-number"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cogi-count-up')) {
    class CogiCountUp extends HTMLElement {
      connectedCallback() {
        // The element can be upgraded mid-parse, before its text node exists,
        // so read the value once the document has finished parsing.
        if (this._cogi_ready) return;
        this._cogi_ready = true;
        const start = () => this.setup();
        // setTimeout rather than requestAnimationFrame: rAF is paused in
        // background tabs, which would leave the element never initialised.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true });
        } else {
          setTimeout(start, 0);
        }
      }

      setup() {
        this._cogi_finalText = this.textContent.trim();

        // Only animate a value that is actually a number, so "4.9 ★" or "24h"
        // still render correctly - the digits animate, the rest stays put.
        const match = this._cogi_finalText.match(/^(\D*)([\d.,\s]+)(\D*)$/);
        if (!match || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this._cogi_prefix = match[1];
        this._cogi_suffix = match[3];
        this._cogi_raw = match[2].trim();
        this._cogi_target = parseFloat(this._cogi_raw.replace(/[\s,]/g, ''));
        if (!isFinite(this._cogi_target)) return;

        this._cogi_decimals = (this._cogi_raw.split('.')[1] || '').length;
        this._cogi_grouped = this._cogi_raw.includes(',');
        this._cogi_duration = (parseFloat(this.dataset.duration) || 1.8) * 1000;

        this._cogi_observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              this._cogi_observer.disconnect();
              this.run();
            }
          },
          { threshold: 0.4 }
        );
        this._cogi_observer.observe(this);
      }

      disconnectedCallback() {
        this._cogi_observer?.disconnect();
      }

      format(value) {
        const fixed = value.toFixed(this._cogi_decimals);
        if (!this._cogi_grouped) return fixed;
        const [whole, fraction] = fixed.split('.');
        const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return fraction ? `${withCommas}.${fraction}` : withCommas;
      }

      run() {
        const start = performance.now();
        const tick = (now) => {
          const progress = Math.min((now - start) / this._cogi_duration, 1);
          // ease-out cubic, so it decelerates into the final figure
          const eased = 1 - Math.pow(1 - progress, 3);
          this.textContent = this._cogi_prefix + this.format(this._cogi_target * eased) + this._cogi_suffix;
          if (progress < 1) requestAnimationFrame(tick);
          else this.textContent = this._cogi_finalText;
        };
        requestAnimationFrame(tick);
      }
    }

    customElements.define('cogi-count-up', CogiCountUp);
  }
  } catch(e) { console.error(e); }
})();

})();
